module.exports = __webpack_public_path__ + "parth7.eebc0a985147f897d8f6.png";


//////////////////
// WEBPACK FOOTER
// E:/Java/ResumeAngular/resume/src/assets/images/parth7.png
// module id = ../../../../../src/assets/images/parth7.png
// module chunks = main